// extracted by mini-css-extract-plugin
export default {"root":"ExpandCollapse_root__v6sp1","button":"ExpandCollapse_button__3_gG3"};